<template>
    <div class="containers">
        <div v-if="goArea == true" class="area-list">
            <CAlert
            v-if="success == true"
            :show.sync="currentAlertCounter"
            closeButton
            style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
            >
            {{alertMess}}
            </CAlert>
            <CAlert
            v-else
            :show.sync="currentAlertCounter"
            closeButton
            style="background-color:red;border-radius:0;text-align:center;color:white"
            >
            {{alertMess}}
            </CAlert>
            <div class="sticky1">
                <CRow>
                    <CCol sm="4"></CCol>
                    <CCol sm="6">
                        <span style="float:right">
                            <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                            <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                            <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                            <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        </span>
                        <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                        <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                        <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                        <!-- <img class="mt-1 mr-5" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                        <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/> -->
                    </CCol>
                    <CCol sm="2">
                        <CButton @click="moving()" type="button" class="btn btn-add">Tambah</CButton>
                    </CCol>
                </CRow>
            </div>
            <Tables @sort="sorting" @delete="deleteData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
            <CModal
                size="sm"
                :centered="true"
                title="Info Delete"
                color="danger"
                :show.sync="deleteModal"
                >
                <p>Apakah anda yakin ingin menghapus data?</p>
                <CRow>
                    <CCol sm="6">
                        <CButton @click="deleteModal = false" class="btn btn-secondary w-100 text-center btn-cancel">Batal</CButton>
                    </CCol>
                    <CCol sm="6">
                        <CButton @click="goSave('D')" class="btn btn-danger w-100 text-center btn-delete">Ya, Hapus</CButton>
                    </CCol>
                </CRow>
                <template #footer-wrapper><span></span></template>
            </CModal>
        </div>
        <div v-else class="area-edit">
            <CRow class="area-back">
                <CCol sm="12">
                    <img class="mt-2 mb-2" @click="moving()" :src="backIcon" width="20px" height="20px" style="float:left;cursor:pointer"/>
                </CCol>
            </CRow>
            <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
            <CRow class="area-input">
                <CCol sm="12">
                    <CRow class="mb-3">
                        <CCol sm="6">
                            <label>Pilih role yang akan dijadikan admin surat</label>
                            <model-select :options="listRole"
                                class="form-control model-select"
                                v-model.trim="$v.role.$model"
                                :class="{ 'is-invalid select-invalid':$v.role.$error, 'is-valid select-valid': !$v.role.$invalid }"
                                placeholder="Pilih Role">
                            </model-select>
                        </CCol>
                    </CRow>
                </CCol>
            </CRow>
            <CRow class="area-button-submit">
                <CCol sm="12">
                    <CButton @click="moving()" type="button" class="btn btn-cancel mr-2">Batal</CButton>
                    <CButton @click="submitForm()" class="btn btn-edit-submit">
                        <span v-if="loading == false">Submit</span>
                        <CSpinner v-else color="default" size="sm"/>
                    </CButton>
                </CCol>
            </CRow>
        </div>
    </div>
    </template>
    
    <script>
    import Tables from '@/component/tableSuratAdmin'
    import {DataApi} from "@/service/DataApi";
    import { required } from 'vuelidate/lib/validators'
    import { validationMixin } from 'vuelidate'
    import { template } from '@babel/core';
    import { ModelSelect } from 'vue-search-select'
    export default {
        components: {
            Tables,
            ModelSelect
        },
        mixins: [validationMixin],
        validations: {
            role: {
                text: {
                    required
                },
                value: {
                    required
                }
            },
        },
        data() {
            return {
                success: true,
                // refreshIcon: require('@/assets/menu/icon_refresh.svg'),
                // moreIcon: require('@/assets/menu/icon_more.svg'),
                backIcon: require('@/assets/menu/icon_goback.svg'),
                dataTh: ['Nama Role', 'Ditambahkan oleh', 'Tanggal ditambahkan', 'Action'],
                dataTd: ['namaRole', 'createdBy', 'createdDate', 'action'],
                styleTable: ['300px','300px','300px','100px'],
                classReload: 'reloadOff',
                goArea: true,
                loading: false,
                alertMess: '',
                currentAlertCounter: 0,
    
                // data model
                listRole: [],
                role: {
                    value: '',
                    text: ''
                },
                unix: '',
                tipe: 'C',
    
    
                // pagination
                page: 1,
                size: 20,
                totalRow: 0,
                totalPage: 1,
                firstPage: 0,
                lastPage: 0,
                
                // datas
                datas: [],
    
                //error
                errorMessage: '',
    
                // delete
                deleteModal: false,
                deleteValue: ''
            }
        },
        watch: {
            page() {
                window.scroll({
                    top:0,
                    left: 0,
                    behavior: 'smooth'
                });
            },
            searchKodeJenis() {
                this.flagSearch = true
            },
            goArea() {
                window.scroll({
                    top:0,
                    left: 0,
                    behavior: 'smooth'
                });
            }
        },
        methods: {
            /**
             * GET DATA
             */
            sorting(value) {
                if(value == 0) {
                    function compare(a,b) {
                        if (a.kodeJenis.toLowerCase() < b.kodeJenis.toLowerCase()) {
                            return -1
                        }
                        if (a.kodeJenis.toLowerCase() > b.kodeJenis.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                }
            },
            getData() {
                this.$store.state.loadingScreen = true
                let payload = {
                    pageIn: this.page,
                    limit: this.size
                }
                DataApi.post("surat/admin/lihat", payload)
                .then(res => {
                    let response = res.data
                    if(response.success == true) {
                        this.datas = response.data.data
                        this.totalRow = response.data.totalRow
                        this.firstPage = (((this.page - 1) * this.size) + 1 )
                        this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                        this.totalPage = Math.floor(this.totalRow/this.size)
                        let modAr = this.totalRow%this.size
                        if(modAr != 0) {
                            this.totalPage = this.totalPage + 1
                        } else {
                            //
                        }
                    } else {
                        this.datas = []
                        this.totalRow = 0
                        this.firstPage = 0
                        this.lastPage = 0
                        this.totalPage = 1
                        this.errorMessage = response.message
                    }
                    this.$store.state.loadingScreen = false
                })
            },
            movePage(direction) {
                if(direction == 'prev') {
                    this.page = this.page -  1
                } else {
                    this.page = this.page +  1
                }
                this.getData()
            },
            validatePage(page) {
                if(page > this.totalPage) {
                    this.page = this.totalPage
                }
            },
    
            /**
             * ADD DATA
             */
            moving() {
                setTimeout(this.moveArea, 600);
            },
            moveArea() {
                if(this.goArea == true) {
                    this.goArea = false
                } else {
                    this.goArea = true
                    this.role.text = ''
                    this.role.value = ''
                    this.deleteValue = ''
                    this.tipe = 'C'
                    this.getDataRole()
                    this.$v.$reset()
                }
            },
            goSave(val) {
                let tipe = ''
                let value = ''
                if(val == 'D') {
                    tipe = 'D'
                    value = this.deleteValue
                } else {
                    tipe = this.tipe
                    value = this.role.value
                }
    
                let payload = {
                    idRole: value,
                    tipe: tipe,
                }
                DataApi.post("surat/admin/simpan", payload)
                .then(res => {
                    this.deleteModal = false
                    let response = res.data
                    if(response.success == true) {
                        if(response.data.Data1 == 'Y') {
                            this.success = true
                        } else {
                            this.success = false
                        }
                        this.alertMess = response.data.Data2
                    } else {
                        this.alertMess = response.message
                        this.success = false
                    }
                    this.getData()
                    tipe == 'C' ? this.moving() : ''
                    this.loading = false
                    this.currentAlertCounter = 7
                })
            },
    
            /**
             * VALIDATION DATA
             */
            submitForm() {
                this.$v.$touch()
                if(this.$v.$invalid) {
                } else {
                    this.goSave()
                    this.loading = true
                }
            },
            getDataRole() {
                this.listRole = []
                let payload = {
                    limit: 9999,
                    nama: '',
                    pageIn: 1
                }
                DataApi.post("menu/role/get", payload)
                .then(res => {
                    let response = res.data.data.data
                    response.forEach(e => {
                        let res = {
                            text: e.namaRole,
                            value: e.idRole
                        }
                        this.listRole.push(res)
                    });
                })
            },
            deleteData(val) {
                this.deleteValue = this.datas[val].idRole
                this.deleteModal = true
            }
        },
        mounted() {
            this.getDataRole()
            this.errorMessage = 'Find Your Data'
            this.getData()
        },
    }
    </script>
    <style scoped>
    .containers {
        background-color: white;
        border-bottom: 1px solid #e5e6e8;
    }
    @media screen and (min-width: 1253px) and (max-width: 1358px) {
        .inputs-form {
            float:left;
            width:100%;
            margin-right: 12px;
            background-color: rgba(249, 250, 252, 1);
        }
    }
    @media screen and (min-width: 1168px) and (max-width: 1252px) {
        .inputs-form {
            float:left;
            width:100%;
            margin-right: 12px;
            background-color: rgba(249, 250, 252, 1);
        }
    }
    @media screen and (min-width: 1097px) and (max-width: 1167px) {
        .inputs-form {
            float:left;
            width:100%;
            margin-right: 12px;
            background-color: rgba(249, 250, 252, 1);
        }
    }
    @media screen and (min-width: 1036px) and (max-width: 1096px) {
        .inputs-form {
            float:left;
            width:100%;
            margin-right: 12px;
            background-color: rgba(249, 250, 252, 1);
        }
    }
    @media screen and (min-width: 992px) and (max-width: 1035px) {
        .inputs-form {
            float:left;
            width:100%;
            margin-right: 12px;
            background-color: rgba(249, 250, 252, 1);
        }
    }
    @media screen and (min-width: 1359px){
        .inputs-form {
            float:left;
            width:100%;
            margin-right: 12px;
            background-color: rgba(249, 250, 252, 1);
        }
    }
    .btn-search {
        border-radius: 4px;
        width: 100%;
        background-color:rgba(48, 107, 221, 1);
        color: white;
    }
    .select-invalid {
        border: 1px solid #e55353 !important;
    }
    .select-valid {
        border: 1px solid #2eb85c !important;
    }
    .btn-search:hover {
        border-radius: 4px;
        width: 100%;
        background-color:rgba(48, 107, 255, 1);
        color: white;
    }
    
    .btn-add {
        border-radius: 4px;
        width: 100%;
        border: 1px solid rgba(48, 107, 221, 1);
        background-color:white;
        color: rgba(16, 16, 16, 1);
        font-weight: 500;
        font-size: 14px;
    }
    .btn-add:hover {
        border-radius: 4px;
        width: 100%;
        border: 1px solid rgba(48, 107, 221, 1);
        background-color: rgba(48, 107, 221, 1);
        color: white;
    }
    .btn-cancel {
        border-radius: 4px;
        width: 200px;
        float: left;
        border: 1px solid rgba(48, 107, 221, 1);
        background-color:white;
        color: rgba(16, 16, 16, 1);
        font-weight: 500;
        font-size: 14px;
    }
    .btn-cancel:hover {
        border-radius: 4px;
        width: 200px;
        float: left;
        border: 1px solid rgba(48, 107, 221, 1);
        background-color: rgba(48, 107, 221, 1);
        color: white;
    }
    .reloadOn {
        float: left;
        cursor: pointer;
        transform: rotate(-180deg);
        transition: 300ms linear all;
    }
    .reloadOff {
        float: left;
        cursor: pointer;
        transform: rotate(180deg);
        transition: 300ms linear all;
    }
    div.search-area {
        padding-top: 12px;
        padding-left: 20px;
        padding-right: 20px;
        padding-bottom: 6px !important;
        background-color: white;
        z-index: 1;
    }
    div.sticky1 {
        position: -webkit-sticky;
        position: sticky;
        top: 54px;
        padding-top: 6px;
        padding-right: 20px;
        padding-left: 20px;
        padding-bottom: 12px !important;
        background-color: white;
        z-index: 1;
    }
    input {
        background-color: rgba(249, 250, 252, 1);
    }
    
    .area-edit {
        background-color: white;
        border-bottom: 1px solid rgba(238, 238, 238, 1);
    }
    .area-back {
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 8px;
        padding-bottom: 8px;
    }
    .area-input {
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 8px;
        padding-bottom: 8px;
    }
    .area-input label {
        font-size: 12px;
        color: rgba(154, 154, 154, 1);
        font-weight: 600;
        margin-bottom: 12px;
    }
    .area-input input {
        background-color: white;
        margin-bottom: 20px;
    }
    .area-button-submit {
        padding-left: 20px;
        padding-bottom: 20px;
    }
    .btn-edit-submit {
        border-radius: 4px;
        float: left;
        width: 200px;
        background-color:rgba(48, 107, 221, 1);
        color: white;
        font-size: 14px;
    }
    .btn-edit-delete {
        border-radius: 4px;
        float: left;
        width: 200px;
        background-color:red;
        color: white;
        font-size: 14px;
    }
    .alert-area {
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 16px;
        padding-bottom: 16px;
        background-color: rgba(48, 107, 221, 1);
        text-align: center;
        color: white;
        font-size: 14px;
    }
    </style>